import type { Table } from "common/data/table";
import type { InstanceOptionSet } from "../options/optionSet";

export const DEFAULT_STUDIO_DOC_NAME = "Untitled Home";
export const STUDIO_DOC_COPY_PREFIX = "Copy of ";

export const BASE_PRESET_NAME = "Base Options";
export const DEFAULT_OPTION_CHOICES = Object.freeze({});
export const EMPTY_INSTANCE_OPTION_SETS: Table<InstanceOptionSet> = Object.freeze({});
